import React from "react";
import { Box, Text, HStack, Link } from "@chakra-ui/react";
import { SocialIcon } from "react-social-icons";
import "./footer.css";

function Footer() {
  const socials = [
    {
      social: "facebook.com/",
      url: "profile.php?id=100066410654013",
      network: "facebook",
      label: "Facebook Profile",
    },
    {
      social: "instagram.com/",
      url: "lead_guitar_lahav_zitayat/",
      network: "instagram",
      label: "Instagram Profile",
    },
    {
      social: "youtube.com/",
      url: "channel/UCdRPu0QOD61UbKF2FYMyOWw",
      network: "youtube",
      label: "YouTube Channel",
    },
    {
      social: "wa.me/",
      url: "972504555498",
      network: "whatsapp",
      label: "WhatsApp Contact",
    },
  ];

  return (
    <footer className="footer-container">
      <Box className="follow-us-container" mb={{ base: "2%", md: "0.5vh" }}>
        <Text
          className="text-container"
          marginBottom="1vh"
          textAlign="center"
          dir="rtl"
          fontSize="1.5rem"
        >
          מוזמנים לעקוב אחרינו:
        </Text>
        <HStack
          className="socials-container"
          spacing={4}
          justifyContent="center"
        >
          {socials.map((social) => (
            <SocialIcon
              key={social.network}
              network={social.network}
              url={`https://${social.social}${social.url}`}
              aria-label={social.label}
              style={{ height: 35, width: 35 }}
            />
          ))}
        </HStack>
      </Box>
      <Text fontSize="2vh">
        Created by:{" "}
        <Link
          href="https://www.linkedin.com/in/daniel-set-1426a52b1/" 
          color="blue.800"
          textDecoration="underline"
          isExternal 
        >
          Daniel Set
        </Link>
      </Text>
    </footer>
  );
}

export default Footer;
